<div class="inner-content transferring"
     *ngIf="groups!= undefined && this.showTransferringContainer && !cancelCreatedLesson">
    <div class="wrapper" *transloco="let t; read: 'transferModal'">

        <div class="image-wrapper">
            <img ngSrc="assets/images/student/transfer_lesson.png" alt="student" height="120" width="120"/>
        </div>

        <div class="teaser" *ngIf="!lessonHasTransferred">
            <span *ngIf="!isParent"> {{t('child.title')}}</span>
            <span *ngIf="isParent"> {{t('parent.title')}} </span>
        </div>


        <div class="title" *ngIf="!lessonHasTransferred">
            <span *ngIf="!isParent"> {{t('child.chooseLesson')}}</span>
            <span *ngIf="isParent"> {{t('parent.chooseLesson')}} </span>
        </div>


        <ion-select *ngIf="!lessonHasTransferred" label="{{t('chooseGroup')}}" label-placement="floating"
                    fill="outline" interface="popover"
                    okText="" cancelText=""
                    class="group-transfer-alert"
                    [(ngModel)]="selectedGroupId"
                    (ionChange)="chooseGroup()"
                    [compareWith]="compareFn">
<!--            <ion-select-option *ngFor="let group of this.groupsTransfer" value="{{group.id}}">{{ group.title|transloco}}</ion-select-option>-->
            <ion-select-option *ngFor="let group of this.groupsTransfer" value="{{group.id}}">{{ group.title}}</ion-select-option>

        </ion-select>


        <ion-select *ngIf="chosenGroup != undefined && !lessonHasTransferred"
                    label="{{t('chooseLesson')}}" label-placement="floating"
                    [ngClass]="{'no-cursor': this.downloadingLessons}"
                    fill="outline" interface="popover"
                    class="group-transfer-alert"
                    [(ngModel)]="fromLessonId"
                    (ionChange)="chooseLessonFrom($event)">>
            <ion-select-option *ngFor="let lesson of this.chosenGroup?.lessons" value="{{lesson.id}}"
                               class="select-transfer-lesson-item"
                               [disabled]="lesson.hasBeenTransfer">
                {{ lesson.date }}, {{lesson.day}}
                - {{ lesson.title }}
                <div> {{ lesson.hasBeenTransfer ? t('transferred'): (lesson.absence ? t('missed') : null) }}</div>
            </ion-select-option>

        </ion-select>


        <div class="available-lessons-container" *ngIf="this.downloadedLessons && !lessonHasTransferred">

<!--            <div class="title" *ngIf="this.getChoseLessonTitle()">{{ this.getChoseLessonTitle() }}-->

<!--            </div>-->

            <div class="title" > {{t('transferTo')}}  </div>

            <ion-radio-group *ngIf="this.availableLessons && this.availableLessons.length>0" class="lessons-wrapper"
                             [ngClass]="{'with-padding-right':this.availableLessons.length>3 }"
                             (ionChange)="chooseLessonTo($event)">
                <ion-radio slot="start" labelPlacement="start" mode="android" class="lesson"
                           *ngFor="let lesson of this.availableLessons; let i = index" value="{{lesson.id}}">
                    <div class="info">
                        <div class="inner-wrapper">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M5.83317 1.45703C6.17835 1.45703 6.45817 1.73685 6.45817 2.08203V2.71763C7.00986 2.70702 7.61767 2.70703 8.28616 2.70703H11.7135C12.382 2.70703 12.9898 2.70702 13.5415 2.71763V2.08203C13.5415 1.73685 13.8213 1.45703 14.1665 1.45703C14.5117 1.45703 14.7915 1.73685 14.7915 2.08203V2.77127C15.0081 2.78779 15.2133 2.80855 15.4074 2.83464C16.3844 2.966 17.1752 3.24276 17.7988 3.8664C18.4224 4.49004 18.6992 5.28083 18.8306 6.25784C18.8725 6.57009 18.9007 6.91085 18.9196 7.28209C18.9445 7.34958 18.9582 7.42254 18.9582 7.4987C18.9582 7.55647 18.9503 7.6124 18.9357 7.6655C18.9582 8.33382 18.9582 9.09266 18.9582 9.95169V11.7124C18.9582 13.2438 18.9582 14.4569 18.8306 15.4062C18.6992 16.3832 18.4224 17.174 17.7988 17.7977C17.1752 18.4213 16.3844 18.6981 15.4074 18.8294C14.458 18.9571 13.245 18.957 11.7135 18.957H8.28616C6.75469 18.957 5.54166 18.9571 4.59232 18.8294C3.6153 18.6981 2.82451 18.4213 2.20087 17.7977C1.57724 17.174 1.30047 16.3832 1.16912 15.4062C1.04148 14.4569 1.04149 13.2438 1.0415 11.7124V9.95168C1.0415 9.09265 1.04149 8.33382 1.06401 7.66551C1.04934 7.6124 1.0415 7.55647 1.0415 7.4987C1.0415 7.42254 1.05512 7.34957 1.08006 7.28208C1.09897 6.91085 1.12714 6.57009 1.16912 6.25785C1.30047 5.28083 1.57724 4.49004 2.20087 3.8664C2.82451 3.24276 3.6153 2.966 4.59232 2.83464C4.78642 2.80855 4.99155 2.78779 5.20817 2.77127V2.08203C5.20817 1.73685 5.48799 1.45703 5.83317 1.45703ZM2.30241 8.1237C2.29177 8.66764 2.2915 9.28702 2.2915 9.9987V11.6654C2.2915 13.2544 2.29283 14.3833 2.40797 15.2397C2.52069 16.0781 2.73208 16.5611 3.08476 16.9138C3.43743 17.2665 3.92047 17.4778 4.75888 17.5906C5.61526 17.7057 6.74415 17.707 8.33317 17.707H11.6665C13.2555 17.707 14.3844 17.7057 15.2408 17.5906C16.0792 17.4778 16.5622 17.2665 16.9149 16.9138C17.2676 16.5611 17.479 16.0781 17.5917 15.2397C17.7068 14.3833 17.7082 13.2544 17.7082 11.6654V9.9987C17.7082 9.28702 17.7079 8.66764 17.6973 8.1237H2.30241ZM17.6401 6.8737H2.35957C2.37292 6.71587 2.38888 6.56639 2.40797 6.4244C2.52069 5.586 2.73208 5.10296 3.08476 4.75028C3.43743 4.39761 3.92047 4.18622 4.75888 4.0735C5.61527 3.95836 6.74415 3.95703 8.33317 3.95703H11.6665C13.2555 3.95703 14.3844 3.95836 15.2408 4.0735C16.0792 4.18622 16.5622 4.39761 16.9149 4.75028C17.2676 5.10296 17.479 5.586 17.5917 6.42441C17.6108 6.56639 17.6268 6.71587 17.6401 6.8737Z"
                                      fill="#3F403F"/>
                            </svg>

                            {{ lesson.dateDay }}, <span> {{ lesson.dateMonthString }}, {{ lesson.time }} </span>

                            <div class="mini-wrapper" *ngIf="lesson.isMini">
                              {{t('isMini')}}

                                <div class="mini-details "
                                     [class.horizontal]="this.setHorizontalPopover || isApp">
                                <div class="mini-popover d-none" [class.show]="isApp && openedPopoverIndex === i" [class.horizontal]="i === 0 || isApp ">
                                    <div class="info" [innerHTML]="t('isMiniDuration',  {duration: lesson.lessonDuration})" >
                                    </div>
                                </div>
                                <img src="assets/images/icons/info.svg"/>
                            </div>

                            </div>
                        </div>

                        <div class="teacher"> {{ lesson.teacher }}</div>
                    </div>
                </ion-radio>
            </ion-radio-group>

            <div class="lessons-no-wrapper"
                 *ngIf="this.availableLessons && this.availableLessons.length == 0 "
                 [innerHTML]="('transfer.message.noLesson')|transloco">
            </div>


            <div class="next-btn">

                <button type="button" class="btn dark-btn"
                        [ngClass]="{'no-cursor': !this.chosenGroup || !this.fromLessonId || !this.toLessonId}"
                        (click)="createLessonTransfer()"> {{t('transferLessonTo')}}
                </button>
            </div>
        </div>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


        <div *ngIf="lessonHasTransferred" class="lesson-has-transfer">
            <div class="title">
                 {{t('lessonTransferred') }}
                <div>
                    {{ transferredToLesson?.dateString }} — {{t('lesson') }} №{{ transferredToLesson?.number }}
                </div>
            </div>

            <div class="transfer-success" *ngIf="!this.isParent"
                 [innerHTML]="('transfer.message.success')|transloco ">
            </div>

            <div class="transfer-success" *ngIf="this.isParent"
                 [innerHTML]="('transfer.message.successParent')|transloco ">
            </div>


            <div class="btn-wrapper">

                <button type="button" class="btn large dark-btn"
                        (click)="cancelCreatedLessonTransfer()"> {{t('cancel') }}
                </button>


                <button type="button" class="btn dark-btn"
                        (click)="closeAndReload()"> ОК
                </button>
            </div>


        </div>


    </div>
</div>


<div class="inner-content transferring"
     *ngIf="showNoGroupsDummy && !cancelCreatedLesson">
    <div class="wrapper" *transloco="let t; read: 'transferModal'">

        <div class="image-wrapper">
            <img ngSrc="assets/images/student/transfer_lesson.png" alt="student" height="120" width="120"/>
        </div>

        <div class="teaser">

           {{t('lessonAvailable') }}

        </div>

        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>
</div>


<div class="inner-content transferring cancel" *ngIf="toCancelLessonData || cancelCreatedLesson">
    <div class="wrapper" *transloco="let t; read: 'transferModal'">

        <div class="image-wrapper">
            <img ngSrc="assets/images/student/transfer_lesson.png" alt="student" height="120" width="120"/>
        </div>

        <div class="title" *ngIf="!cancelCreatedLesson && this.cancelSucceeded == undefined">
             {{t('toCancel') }}
        </div>


        <div class="title" *ngIf="this.cancelSucceeded">
         {{t('cancelled') }}
        </div>

        <div class="title" *ngIf="this.cancelSucceeded == false">
            {{t('cancelledFailed') }}
        </div>


        <div class="title" *ngIf="cancelCreatedLesson && this.cancelSucceeded == undefined">
             {{t('toCancelTransferredLesson')}}

            <div>   {{t('lessonNumber')}} {{ transferredToLesson?.number }}- {{ transferredToLesson?.dateString }}</div>
        </div>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>

        <div class="cancel">
            <div class="btn-wrapper" *ngIf=" this.cancelSucceeded == undefined">

                <button type="button" class="btn dark-btn"
                        (click)="closeAndReload()"> {{ 'no' |transloco }}
                </button>


                <button type="button" class="btn green-btn"
                        (click)="cancelLessonTransfer()"> {{ 'yes' |transloco }}
                </button>
            </div>

            <div class="btn-wrapper cancel-succeeded" *ngIf="this.cancelSucceeded">

                <button type="button" class="btn green-btn"
                        (click)="closeAndReload()"> Ok
                </button>

            </div>

        </div>


    </div>
</div>




